webpackJsonp([1],{

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SignIn__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SignIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SignIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainNav__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MainNav__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { SignIn: __WEBPACK_IMPORTED_MODULE_1__components_SignIn___default.a, MainNav: __WEBPACK_IMPORTED_MODULE_2__components_MainNav___default.a },
  data: function data() {
    return {
      user: null,
      loading: true,
      activeIndex: null
    };
  },

  methods: {
    signIn: function signIn() {
      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* launchSignIn */])();
    },
    menuSelect: function menuSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* auth */].signOut();
    }
  },
  created: function created() {
    var _this = this;

    // Show a loading indicator until we figure out of the user is logged in our not
    __WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* auth */].onAuthStateChanged(function (user) {
      _this.user = user;
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlaidLink__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlaidLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PlaidLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: { PlaidLink: __WEBPACK_IMPORTED_MODULE_0__PlaidLink___default.a },
  data: function data() {
    return {
      accounts: [],
      items: [],
      transactions: [],
      pl_transactions: []
    };
  },
  mounted: function mounted() {
    var uid = __WEBPACK_IMPORTED_MODULE_1__api_js__["b" /* auth */].currentUser.uid;
    this.$bindAsArray('accounts', __WEBPACK_IMPORTED_MODULE_1__api_js__["c" /* db */].ref('accounts/' + uid));
    this.$bindAsArray('items', __WEBPACK_IMPORTED_MODULE_1__api_js__["c" /* db */].ref('items'));
    this.$bindAsArray('transactions', __WEBPACK_IMPORTED_MODULE_1__api_js__["c" /* db */].ref('transactions/' + uid));
    this.$bindAsArray('pl_transactions', __WEBPACK_IMPORTED_MODULE_1__api_js__["c" /* db */].ref('pl_transactions/' + uid));
  },

  computed: {
    transactionCount: function transactionCount() {
      return this.transactions.length;
    },
    plaidTransactionCount: function plaidTransactionCount() {
      return this.pl_transactions.length;
    }
  },
  methods: {
    getPending: function getPending(isPending) {
      return isPending ? 'true' : 'false';
    }
  }

});

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'items'
});

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainNav',
  props: ['email'],
  methods: {
    signOut: function signOut() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_firebase__["auth"])().signOut();
    }
  }
});

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_js__ = __webpack_require__(19);


//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PlaidLink',
  created: function created() {
    /* global Plaid */
    this.handler = Plaid.create({
      apiVersion: 'v2',
      clientName: 'SmartPath Plaid',
      env: 'development',
      product: ['transactions'],
      key: '82f82030fd66f81fc48d69eb46df4b',
      webhook: 'https://us-central1-pokrzyk-plaid.cloudfunctions.net/plaid',
      onSuccess: this.savePublicToken
    });
  },

  methods: {
    savePublicToken: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(public_token, metadata) {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = {
                  command: 'process_public_token',
                  public_token: public_token,
                  instituion_id: metadata.institution.institution_id,
                  institution_name: metadata.institution.name
                };

                console.log(payload);
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_js__["d" /* command */])(payload);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function savePublicToken(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return savePublicToken;
    }(),
    deleteAll: function deleteAll() {
      __WEBPACK_IMPORTED_MODULE_2__api_js__["c" /* db */].ref().remove();
    }
  }
});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_js__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profile',
  data: function data() {
    return {
      labelPosition: 'right',
      authUser: {},
      dbUser: {}
    };
  },
  mounted: function mounted() {
    this.authUser = __WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* auth */].currentUser;
    var ref = __WEBPACK_IMPORTED_MODULE_0__api_js__["c" /* db */].ref('/users').child(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* auth */].currentUser.uid);
    this.$bindAsObject('dbUser', ref);
  }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auth',
  props: ['onClick']
});

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuefire__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuefire___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App />',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return auth; });
/* harmony export (immutable) */ __webpack_exports__["a"] = launchSignIn;
/* harmony export (immutable) */ __webpack_exports__["d"] = command;
/* unused harmony export exchangeToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);





var firebase = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyCoebrHrFivoWVvVqwswf5HYwB-YW9GcEI',
  authDomain: 'pokrzyk-plaid.firebaseapp.com',
  databaseURL: 'https://pokrzyk-plaid.firebaseio.com',
  projectId: 'pokrzyk-plaid',
  storageBucket: 'pokrzyk-plaid.appspot.com',
  messagingSenderId: '876934432144'
});

var db = firebase.database();
var auth = firebase.auth();

function launchSignIn() {
  var provider = new __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth.GoogleAuthProvider();
  provider.addScope('profile');
  auth.signInWithRedirect(provider);
  auth.getRedirectResult();
}

function command(payload) {
  payload.timestamp = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.database.ServerValue.TIMESTAMP;
  db.ref('commands').child(auth.currentUser.uid).push(payload);
}

var exchangeToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2__Users_jon_github_pokrzyk_plaid_web_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(publicToken) {
    var url, body, res, ret;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = 'https://us-central1-pokrzyk-plaid.cloudfunctions.net/exchangeToken';
            body = {
              public_token: publicToken,
              uid: auth.currentUser.uid
            };
            _context.next = 4;
            return fetch(url, {
              method: 'POST',
              headers: {
                'Content-type': 'application/json'
              },
              mode: 'no-cors',
              body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(body)
            });

          case 4:
            res = _context.sent;
            _context.next = 7;
            return res.text();

          case 7:
            ret = _context.sent;

            console.log(ret);
            return _context.abrupt('return', ret);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function exchangeToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffcaa258",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0758cb76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(220),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(221),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56dd3078",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(224),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7ea8e12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/items"
    }
  }, [_vm._v("Items")]), _vm._v(" "), _c('el-submenu', {
    staticClass: "profile",
    attrs: {
      "index": "user"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/profile"
    }
  }, [_vm._v("Profile")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "signout"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign out")])])], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.handler.open()
      }
    }
  }, [_vm._v("\n    Add Account\n  ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "delete"
    },
    on: {
      "click": function($event) {
        _vm.deleteAll()
      }
    }
  }, [_vm._v("\n    Delete All\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    attrs: {
      "header": "Auth Profile"
    }
  }, [_c('el-form', {
    staticClass: "form",
    attrs: {
      "label-width": "100px",
      "model": _vm.authUser
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UID"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.authUser.uid),
      callback: function($$v) {
        _vm.authUser.uid = $$v
      },
      expression: "authUser.uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.authUser.email),
      callback: function($$v) {
        _vm.authUser.email = $$v
      },
      expression: "authUser.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.authUser.displayName),
      callback: function($$v) {
        _vm.authUser.displayName = $$v
      },
      expression: "authUser.displayName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "Database Profile"
    }
  }, [_c('el-form', {
    staticClass: "form",
    attrs: {
      "label-width": "100px",
      "model": _vm.dbUser
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "UID"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dbUser.uid),
      callback: function($$v) {
        _vm.dbUser.uid = $$v
      },
      expression: "dbUser.uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dbUser.email),
      callback: function($$v) {
        _vm.dbUser.email = $$v
      },
      expression: "dbUser.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Name"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dbUser.name),
      callback: function($$v) {
        _vm.dbUser.name = $$v
      },
      expression: "dbUser.name"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.loading) ? _c('div', [(_vm.user) ? _c('div', [_c('main-nav', {
    attrs: {
      "email": _vm.user.email
    }
  }), _vm._v(" "), _c('div', [_c('router-view', {
    attrs: {
      "id": "main"
    }
  })], 1)], 1) : _c('div', [_c('sign-in', {
    attrs: {
      "onClick": _vm.signIn
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Plaid Items")]), _vm._v(" "), _c('p', [_vm._v("Here are your plaid items")])])
}]}

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    attrs: {
      "header": "Pokrzyk-Plaid"
    }
  }, [_c('div', {
    attrs: {
      "id": "auth-card"
    }
  }, [_c('div', [_vm._v("Use your google account to sign in.")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "http://google.com"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "button_logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "button_text"
  }, [_vm._v("Sign in with Google")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Home")]), _vm._v(" "), _c('plaid-link'), _vm._v(" "), _c('el-table', {
    staticClass: "top",
    attrs: {
      "data": _vm.accounts
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "institution_name",
      "label": "Institution",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subtype",
      "label": "Sub Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "current",
      "label": "Balance"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticClass: "top",
    attrs: {
      "data": _vm.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "item.institution_name",
      "label": "Institution",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "UID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "access_token",
      "label": "Access Token"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item.webhook",
      "label": "Webhook"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "header": "Plaid Transaction Count"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.plaidTransactionCount))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "cards",
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "header": "User Transaction Count"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.transactionCount))])])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "top",
    attrs: {
      "data": _vm.transactions,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "date",
      "label": "Date",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "amount",
      "label": "Amount",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "category",
      "label": "Category",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Pending",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.pending ? 'true' : 'false') + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "name",
      "label": "Name"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Items__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Items___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Items__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Profile__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/items',
    name: 'Items',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Items___default.a
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Profile___default.a
  }]
}));

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(222),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[119]);


// WEBPACK FOOTER //
// static/js/app.fc48cc4f40855f842628.js